export default __webpack_public_path__ + "static/media/blog_home.b1d14b4f.webp";